import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Zoom,
} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import MasterEntryExtraFields from "./MasterEntryExtraFields";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: "150ms" }} ref={ref} {...props} />;
});

const emptyValues = {
  code: "",
  name: "",
  description: "",
  category: "",
  museum_type_id: "",
  storage_room_id: "",
  ownership_id: "",
  object_group_id: "",
  classification_id: "",
  sub_group_id: "",
  items: [],
  visitor_type_id: "",
  museum_exhibition_type_id: "",
  ticket_fee_id: "",
  fee: "",
  from_date: "",
  to_date: "",
  discount_rate: "",
  status: "active",
};

export default function MasterEntryDialog({ open, entry, categoryId, onClose, onSubmit }) {
  const initialValues = entry ? { ...emptyValues, ...entry } : emptyValues;
  const showCodeField = categoryId !== "categories" && categoryId !== "master_items";
  const showStatusField = false; // Removed ticket_fees from master data

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      maxWidth={"sm"}
      aria-describedby="master-entry-dialog"
    >
      <DialogTitle color={"#616B88"} sx={{ fontSize: 24 }} className={"text-bold"} fontWeight={700}>
        {entry ? "Edit Master Entry" : "Add Master Entry"}
      </DialogTitle>
      <Box className={"common-divider"} />

      <Formik
        initialValues={
          entry
            ? {
                code: entry.code || "",
                name: entry.name || "",
                description: entry.description || "",
                museum_type_id: entry.museum_type?.id || entry.museum_type_id || "",
                visitor_type_id: entry.visitor_type?.id || entry.visitor_type_id || "",
                museum_exhibition_type_id:
                  entry.museum_exhibition_type?.id || entry.museum_exhibition_type_id || "",
                ticket_fee_id: entry.ticket_fee?.id || entry.ticket_fee_id || "",
                storage_room_id: entry.storage_room?.id || entry.storage_room_id || "",
                ownership_id: entry.ownership?.id || entry.ownership_id || "",
                object_group_id: entry.object_group?.id || entry.object_group_id || "",
                // Dimensions tab: classification may arrive as classification, object_group, or *_id
                classification_id:
                  entry.classification?.id ||
                  entry.object_group?.id ||
                  entry.classification_id ||
                  entry.object_group_id ||
                  "",
                // Dimensions tab: sub group may arrive as sub_group, object_sub_group, or *_id
                sub_group_id:
                  entry.sub_group?.id ||
                  entry.object_sub_group?.id ||
                  entry.sub_group_id ||
                  entry.object_sub_group_id ||
                  "",
                category: entry.category || "",
                items: entry.items || [],
                fee: entry.fee ?? "",
                from_date: entry.from_date || "",
                to_date: entry.to_date || "",
                discount_rate: entry.discount_rate || "",
                status: entry.status || "active",
              }
            : emptyValues
        }
        onSubmit={(values) => onSubmit?.({ ...values, id: entry?.id })}
        enableReinitialize
      >
        {({ setFieldValue, values }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <MasterEntryExtraFields categoryId={categoryId} />

                {showCodeField && (
                  <Grid item xs={12} sm={6}>
                    <Field
                      component={TextField}
                      variant={"outlined"}
                      size={"small"}
                      fullWidth
                      label={"Code"}
                      name={"code"}
                      InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <Field
                    component={TextField}
                    variant={"outlined"}
                    size={"small"}
                    fullWidth
                    label={"Name"}
                    name={"name"}
                    InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    variant={"outlined"}
                    size={"small"}
                    fullWidth
                    multiline
                    minRows={3}
                    label={"Description"}
                    name={"description"}
                    InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
                  />
                </Grid>

                {showStatusField && (
                  <Grid item xs={12}>
                    <FormControl>
                      <RadioGroup
                        row
                        name="status"
                        value={values.status}
                        onChange={(e) => setFieldValue("status", e.target.value)}
                      >
                        <FormControlLabel value="active" control={<Radio />} label="Active" />
                        <FormControlLabel value="inactive" control={<Radio />} label="Inactive" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose} variant={"outlined"} color={"error"} className={"text-capitalize"}>
                cancel
              </Button>
              <Button variant={"contained"} type={"submit"} className={"text-capitalize"}>
                {entry ? "Update" : "Submit"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
